import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackageExceptionsComponent } from './package-exceptions.component';

@NgModule({
    imports: [SharedModule],
    declarations: [PackageExceptionsComponent],
    entryComponents: [PackageExceptionsComponent],
    exports: [PackageExceptionsComponent]
})
export class PackageExceptionsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/package-exceptions/package-exceptions.module.ts